import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

function logLevelColor (level) {
  if (level === 'error') return 'var(--color-danger-600)'
  if (level === 'warn') return 'var(--color-warning-600)'
  return 'var(--color-neutral-400)'
}

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    gap: '6px',
    padding: '3px 0',
    fontSize: '12px',
    fontFamily: 'var(--font-mono, monospace)'
  },
  level: {
    minWidth: '38px',
    fontWeight: 600,
    flexShrink: 0
  },
  message: {
    color: 'var(--color-neutral-700)',
    wordBreak: 'break-word'
  }
}))

function LogRow ({ log }) {
  const classes = useStyles()
  return (
    <div className={classes.row}>
      <span className={classes.level} style={{ color: logLevelColor(log.level) }}>
        [{log.level}]
      </span>
      <span className={classes.message}>{log.message}</span>
    </div>
  )
}

LogRow.propTypes = {
  log: PropTypes.shape({
    level: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
  }).isRequired
}

export { logLevelColor }
export default LogRow
